<template>
    <div>
        <div class="sidebar-wrapper">
            <h3>Магазин</h3>
         <ul class="ul-sidebar">
            <!-- <li v-for="link in links" :key="link.id">
                <router-link :to="{ name: link.name }">{{ link.title }} </router-link>

            </li> -->

            <!-- <li v-if="user.role_id > 19">
                <router-link :to="{ name: 'files' }">Файли </router-link>
            </li>
            <li v-if="user.role_id > 19">
                <router-link :to="{ name: 'shop-product' }">Магазин </router-link>
            </li>
            <li v-if="user.role_id == 2 || user.role_id > 19">
                <router-link :to="{ name: 'task-product-open' }">Задачи </router-link>
            </li>
            <li v-if="user.role_id > 19">
                <router-link :to="{ name: 'users' }">Ползватели </router-link>
            </li>
            <li v-if="user.role_id > 19">
                
                <router-link :to="{ name: 'module-slider' }">Модули </router-link>
            </li> -->

            <li>
                <router-link :to="{ name: 'shop-product' }">Продукти </router-link>
            </li>
            <li>
                <router-link :to="{ name: 'shop-category' }">Категории </router-link>
            </li>
            <li>
                <router-link :to="{ name: 'shop-filter' }">Филтри </router-link>
            </li>
              <li>
                <router-link :to="{ name: 'shop-brand' }">Производители </router-link>
            </li>
              <li>
                <router-link :to="{ name: 'shop-sell-company' }">Рекламни Компании </router-link>
            </li>



        </ul>
       
    </div>
</div>

</template>

<script>
   // import axios from 'axios'

   export default {
    name: 'left-sidebar',
    data() {
        return {
           
        }
    },


    created() {

        this.$store.dispatch('retrieveUser')
        .then(response => {

        })
        .catch(error => {
        })
    },

    computed: {
        user() {
            return this.$store.getters.getUser
        },
    }
}
</script>


<style scoped>
.bottom-sidebar {
    font-size:12px;
    padding: 0 30px 0 0;
}
.progress-bar {
    height: 6px;
    border-radius: 10px;
}
.wrap-progress-bar {
    height:6px;
    width: 100%;
    background: #e1e1e1;
    border-radius: 10px;
}
.bottom-sidebar {
    margin-top: 170%;
}
.uploads {
    margin-top: 200%;
}
.sidebar-wrapper {
    position: fixed;
    z-index: 10;
    width: 200px;
}
.sidebar-wrapper h3 {
    height: 32px;
    line-height: 32px;
    margin: 16px 0 4px;
    padding: 0 12px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: #707070;
}
.ul-sidebar {
    height: 100%;

}
.ul-sidebar li {
    position: relative;
    margin: 3px 0;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 125ms ease-out,color 125ms ease-out;
}
.ul-sidebar li:before {
content: "#";
    color: #006886;
    position: absolute;
    left: -2px;
    margin-top: 8px;
    padding-right: .5em;
    font-size: 13px;
    line-height: 1;
    font-weight: 700;
}
    
.ul-sidebar li a {
    background-color: transparent;
    color: #4b4b4b;
    display: inline-flex;
    min-height: 32px;
    width: 100%;
    padding: 5px 12px;

}
.ul-sidebar li a:hover {
    position: relative;
    /*background-color: rgba(44,44,44,.06);*/
}
.ul-sidebar li a:hover:after {
    /*width: 99%;*/
    background-color: #006886;
}
.ul-sidebar li a:after {
    content: '';
    transition: all 1s;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: all 1s;

    height: 1px;
    width: 0;

    /*border-bottom: 2px solid #17a2b8!important;*/
}
.router-link-active {
    color: #17a2b8!important;
    font-weight: bold;
    width: 50%!important;
    /*border-bottom: 2px solid #17a2b8!important;*/
}
/*.router-link-active:after {
    width: 50%!important;
    border-bottom: 2px solid #17a2b8!important;
}*/
</style>


// WEBPACK FOOTER //
// src/components/layouts/LeftSidebar.vue